import { ICurrentUser } from '../model/types';

export const transformResponse = (response: ICurrentUser): ICurrentUser => {
  return {
    ...response,
  };
};
